import React, { useEffect, useRef, useState } from 'react';
import { ImageEntity, GlobalCta } from 'src/modules/global';
import _ from 'lodash';

// import { Row, Col } from 'antd';
// import { rowDefaultProps } from 'src/utils/grid';
// import { Button } from 'src/modules/global/components/button/Button';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import styles from './LayoutBlockFullHero.module.scss';
import { connect } from 'react-redux';
import { updateHeroBox } from 'src/modules/layout';
import { defaultHorizontalGutter } from 'src/utils/grid';
import { Col, Row } from 'antd';
import { withBreakpoints } from 'react-breakpoints';

export interface LayoutBlockFullHeroProps {
  title: string;
  subline?: string | React.ReactNode;
  image: ImageEntity;
  mobile_image?: ImageEntity;
  button?: CtaProps;
  dispatch: any;
  currentBreakpoint: string;
}

const LayoutBlockFullHero: React.FunctionComponent<LayoutBlockFullHeroProps> = (
  props: LayoutBlockFullHeroProps
) => {
  const { title, subline, image, mobile_image, button, dispatch, currentBreakpoint } = props;
  const heroRef = useRef<HTMLDivElement>(null);

  const [responsiveImage, setResponsiveImage] = useState(image);

  useEffect(() => {
    const useMobileImage = _.includes(['xs', 'sm'], currentBreakpoint) && !_.isEmpty(mobile_image);
    setResponsiveImage(useMobileImage ? mobile_image : image);
  }, [currentBreakpoint, image, mobile_image]);

  useEffect(() => {
    const publishBox = () => {
      if (heroRef.current) {
        const heroHeight = heroRef.current.offsetHeight;
        // console.log('hero scroll update');
        dispatch(
          updateHeroBox({
            height: heroHeight,
          })
        );
      }
    };

    window.addEventListener('resize', publishBox);

    publishBox();

    return () => {
      // console.log('reset');
      window.removeEventListener('resize', publishBox);
    };
  }, [dispatch]);

  useEffect(() => {
    return () => dispatch(updateHeroBox(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container} ref={heroRef}>
      {!!responsiveImage && (
        <img key={responsiveImage?.url} alt={responsiveImage?.alt} src={responsiveImage?.url} />
      )}

      <div className={styles.lineAnimated}>
        <div className={styles.lineAnimatedInnerContainer} />
      </div>

      {/* <Row {...rowDefaultProps} className={styles.container}>
        <Col span={24} className={styles.column}> */}
      <div className={styles.textColumn}>
        <Row gutter={[defaultHorizontalGutter, 0]}>
          <Col md={6} sm={0} xs={0} lg={0} />
          <Col md={12} sm={24} xs={24} lg={24}>
            <h1 className={styles.title}>{title}</h1>
            {typeof subline === 'string' && (
              <div className={styles.subline} dangerouslySetInnerHTML={{ __html: subline }} />
            )}
            {!!button && <GlobalCta {...button} widthType="padded" />}
          </Col>
          <Col md={6} sm={0} xs={0} lg={0} />
        </Row>
      </div>
    </div>
  );
};

export default connect()(withBreakpoints(LayoutBlockFullHero));
